import key from 'weak-key';
import { Col, Row, Divider } from '@geberit/gdds';

// styles
import styles from './media-releases.module.scss';

// components
import Download, { File } from './download';
import { Translation } from 'components/Translation/Translation';

// utils
import { validateDate } from 'utils/validateDate';
import { decodingContent } from 'utils/decodingContent';
import { useCurrentLanguageFromLocale } from 'utils/hooks/useCurrentLanguage';
import { isEmpty } from 'utils/is-empty';
import { useLocale } from 'utils/use-locale';

interface ReleaseProps {
  title: string;
  date: string;
  adHoc?: boolean;
  files?: File[];
}

function Release({ title, date, adHoc = false, files = [] }: Readonly<ReleaseProps>) {
  const language = useCurrentLanguageFromLocale();
  const locale = useLocale(language);
  const dateformat = language === 'de' ? 'dd. MMMM yyyy' : 'dd MMMM yyyy';

  return (
    <>
      <Row className={styles.rowTitle}>
        <Col size={[4, 8, 5]}>
          <span>{decodingContent(title)}</span>
        </Col>
        <Col size={[4, 8, 4]}>
          <span>{adHoc && <Translation id="group_media_releases_adhoc" />}</span>
        </Col>
        <Col size={[4, 8, 3]}>{validateDate(new Date(date), dateformat, locale)}</Col>
      </Row>
      {!isEmpty(files) && (
        <Row>
          <Col size={[4, 8, 12]}>
            <div className={styles.links}>
              {files.map((file) => (
                <Download key={key(file)} {...file} />
              ))}
            </div>
          </Col>
        </Row>
      )}
      <Row>
        <Col size={[4, 8, 12]} className={styles.divider}>
          <Divider />
        </Col>
      </Row>
    </>
  );
}

export default Release;
